import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'abc-under-construction',
  templateUrl: './abc-under-construction.component.html',
  styleUrls: ['./abc-under-construction.component.css']
})
export class AbcUnderConstructionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
